module.exports = __webpack_public_path__ + "img/sem_acesso.295e9360.png";